<div class="container" rtl>

    <lgv-loading-indicator *ngIf="isLoading"></lgv-loading-indicator>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1>Activity Log</h1>
            </div>
            <div class="col-lg-3 d-none d-lg-block"></div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" matInput placeholder="Search">
                </mat-form-field>
            </div>
        </div>
        <div class="Vert-20"></div>
    </div>
    <!----------------Mobile View------------->
    <!-- <div class="row d-block d-md-none mobile-view" *ngIf="loanApplications$ | async as log">
        <div class="col-md-4">

            <mat-card class="standardized" style="min-height: 200px !important;" *ngFor="let x of log; let i = index" id="{{ '' + i }}">
                <mat-card-subtitle rtl>
                    <div class="mat-card-header">
                        <a (click)="goToClientDocPage(x.id)">
                            {{!!x?.loanInfo?.loanNumber ? x?.loanInfo?.loanNumber : 'Pending'}}</a>
                    </div>
                </mat-card-subtitle>
                <mat-card-content>
                    <table width="100%">
                        <tr>
                            <div (click)="showBorrowerModal(x)">{{getBorrowerNames(x)}}</div>
                        </tr>
                        <tr>{{!x.loanInfo?.subjectPropertyAddress?.street ? 
                            x.loanInfo?.subjectPropertyAddress?.state + ', TBD' : x.loanInfo?.subjectPropertyAddress?.street}} <br>
                            <span style="font-size: 12px; font-weight: bold;">{{x?.loanInfo?.purpose?.name}}</span>
                        </tr>
                        <tr>
                            <div class="task-cell">
                                <div *ngFor="let task of x.taskSummaries">
                                    <div
                                        [ngClass]="{'requested': task.status?.name == 'Requested', 'accepted': task.status?.name == 'Accepted','uploaded': task.status?.name == 'Uploaded'}">
                                        <span>{{task.count}}</span>
                                    </div>
                                </div>
                            </div>
                        </tr>
                        <tr> {{!!x?.loanInfo?.loanNumber ? x?.loanInfo?.loanStatus?.name : 'App Started'}}</tr>
                        <tr *ngIf="!(lgvUserSvc.IsAgent$ | async)">{{getLoanOfficerName(x.loanInfo?.assignments?.loanOfficer)}}</tr>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>
        <lgv-grid-pager *ngIf="Clients$ | async" [GridMgr]="GridMgr"></lgv-grid-pager>
    </div> -->
    <!----------------Large View------------->
    <div class="d-none d-md-block d-lg-block d-xl-block d-xxl-block row item">
        <div class="col-12">
            <table class='table table-striped'>
                <thead>
                    <tr>
                        <th>
                            <lgv-grid-header [HeaderText]="'Date'" [SortField]="'updatedTimestampUtc'" [Mgr]="GridMgr">
                            </lgv-grid-header>
                        </th>
                        <th>
                            <lgv-grid-header [HeaderText]="'User'" [SortField]="'updatedByFirstName'" [Mgr]="GridMgr">
                            </lgv-grid-header>
                        </th>
                        <th style="max-width: 400px !important;">
                            <lgv-grid-header [HeaderText]="'Actions'" [SortField]="'changes'" [Mgr]="GridMgr">
                            </lgv-grid-header>
                        </th>
                    </tr>
                </thead>
                <tbody *ngIf="activityLogs$ | async as logs">
                    <ng-container *ngFor="let log of logs; let i = index" id="{{ '' + i }}">
                        <tr>
                            <td><div class="tooltipcell">{{log?.updatedTimestampUtc | date: 'MM/dd/yy'}}
                                <span class="tooltiptext" [innerHTML]="log?.updatedTimestampUtc"></span>
                            </div>
                            </td>
                            <td>{{log?.updatedByFirstName + ' ' + log?.updatedByLastName}}
                            </td>
                            <td  style="max-width: 400px !important;" [innerHtml]="getActionList(log?.changes)">
                            </td>
                        </tr>
                    </ng-container>
                    
                </tbody>
            </table>
        </div>
    </div>

    <div class="pagination">
        <p>{{((currentPage-1) * countPerPage) + 1}} - {{countPerPage}} of {{totalCount}} events <a (click)="previousPage()"><fa-icon icon="caret-left"></fa-icon></a>  &nbsp;<a (click)="nextPage()"><fa-icon icon="caret-right"></fa-icon></a></p>
    </div>
</div>
